<router-outlet>
    <app-modal></app-modal>
</router-outlet>
<app-loading-spinner-fullscreen *ngIf="loadingSpinnerVisible"></app-loading-spinner-fullscreen>
